export const CUSTOMER_DATA_URL = "/data/payload.json";
export const CUSTOMER_LOGO_URL = "/data/logo.png";
export const CUSTOMER_CSS_URL = "/data/style.css";
export const CUSTOMER_RSS_URL = "/data/rss.xml";
export const EMAIL_SUBSCRIPTION_URL = "/status_page_subscriptions";
//export const RECAPTCHA_SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
